<template>
    <div class="flex relative space-x-2">
        <div @click="handleShowColorsModal" :class="[
          'w-6 h-6 won-tag-light-gray rounded-md',
          'cursor-pointer flex items-center justify-center select-none',
        ]" >
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#clip0_1_25283)">
            <path d="M4.57501 14.1667H6.59168L7.65001 11.1833H12.3583L13.4083 14.1667H15.425L11.0417 2.5H8.95835L4.57501 14.1667ZM8.25835 9.49167L9.95001 4.66667H10.05L11.7417 9.49167H8.25835Z" :fill="fillLinkColor"/>
            <path d="M18.3334 16.667H1.66669V20.0003H18.3334V16.667Z" :fill="fillBorderBottomWithSelectedColor"/>
            </g>
            <defs>
            <clipPath id="clip0_1_25283">
            <rect width="20" height="20" fill="white"/>
            </clipPath>
            </defs>
            </svg>
        </div>

        <div v-if="visibleColorModal" v-click-outside="handleClickOutside" class="absolute inset-x-0 flex flex-wrap justify-start p-1 items-center mt-6 w-[145px] rounded shadow-lg bg-[#FFFFFF] border border-[#DBDBDC] z-40">
            <div @click="() => handleSetColor(color)" v-for="color in colors" :key="color" :style="[{ backgroundColor: color }, [editor.isActive('textStyle', { color: color }) ? {'--tw-ring-color': color} : null]]" :class="['flex justify-center items-center rounded-full w-[20px] h-[20px] ml-1.5 cursor-pointer mt-1.5 ', { [`ring-[1px] ring-offset-1`]: editor.isActive('textStyle', { color: color }) }]">
                <svg v-if="editor.isActive('textStyle', { color })" width="10" height="8" viewBox="0 0 10 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M3.50002 6.08504L1.41502 4.00004L0.705017 4.70504L3.50002 7.50004L9.50002 1.50004L8.79502 0.795044L3.50002 6.08504Z" fill="#F9FBFA"/>
                </svg>
            </div>

            <div @click="triggerColor" class="rounded-full w-[20px] h-[20px] inline-flex justify-center items-center bg-[#EFF6FF] ring-[1px] ring-offset-1 ring-[#5282EB] ml-1.5 cursor-pointer mt-1.5">
                <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M7.77778 5.00005H2.22223" stroke="#5283EB" stroke-linecap="round"/>
                    <path d="M4.99999 2.22229V7.77785" stroke="#5283EB" stroke-linecap="round"/>
                </svg>
            </div>
            <input type="color" ref="color" class="invisible h-0 w-0" @input="e => handleSetColor(e.target.value)" :value="editor ? editor.getAttributes('textStyle').color : null" />
        </div>
    </div>
</template>

<script setup>
import { ref, computed } from 'vue'
import { useTiptapStore } from '../../store/tiptap.store'
import { storeToRefs } from 'pinia'
import { rgbToHex, checkIfEmpty } from '../../utils/helpers'

const tiptap = useTiptapStore()
const { editor, isFocused } = storeToRefs(tiptap)

let colors = ['#000000', '#515151', '#17296F', '#4E96D8', '#255514', '#63349F', '#8F3821', '#EA917D', '#DFA93B']
const color = ref(null)
const triggerColor = () => {
    color.value.click()
}

const visibleColorModal = ref(false)
const handleShowColorsModal = () => {
    const currentSelectionIsEmpty = editor.value ? editor.value.view.state.selection.empty : true
    if(currentSelectionIsEmpty) return

    // selected default color
    let selectedColor = editor.value.getAttributes('textStyle').color
    if(selectedColor && selectedColor.match(/(rgb)+/g)) {
        let [r,g,b] = selectedColor.match(/\d+/gm)
        const selectedHexColor = rgbToHex(parseInt(r),parseInt(g),parseInt(b))
        handleSetColor(selectedHexColor.toUpperCase())
    }
    
    visibleColorModal.value = true
}
const handleHideColorsModal = () => visibleColorModal.value = false
const handleClickOutside = () => {
    handleHideColorsModal()
}

const handleSetColor = color => {
    editor.value.chain().focus().setColor(color).run()
}

const fillBorderBottomWithSelectedColor = computed(() => {
    let color = editor.value ? editor.value.getAttributes('textStyle').color : null
    return isFocused.value && editor.value ? (checkIfEmpty(color) ? '#333333' : color) : '#333333'
})
const fillLinkColor = computed(() => visibleColorModal.value === true ? '#2A8176' : '#444C58')
</script>
